import { Reveal } from "./Reveal";

export const SectionHeading = ({ chapter, kicker, title, subtitle, align = "left" }) => (
  <div className={align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
    <Reveal>
      <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
        <span className="h-px w-8 bg-[#D4AF37]/60" aria-hidden="true" />
        <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37] uppercase">
          {chapter} — {kicker}
        </span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-[1.08]">
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base sm:text-lg text-[#99A1AF] leading-relaxed ${align === "center" ? "mx-auto" : ""} max-w-2xl`}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
